import React from 'react';

const SvgSm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SM_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SM_svg__b" fill="#fff">
        <use xlinkHref="#SM_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#7CCCF5" mask="url(#SM_svg__b)" d="M0 9.333h28V20H0z" />
      <path
        d="M11.333 9.333c0 .986.535 1.847 1.33 2.308m2.772-.06a2.665 2.665 0 0 0 1.232-2.248"
        stroke="#445F42"
        strokeWidth={1.333}
        strokeLinecap="round"
        mask="url(#SM_svg__b)"
      />
      <ellipse
        fill="#D89F3D"
        mask="url(#SM_svg__b)"
        cx={14}
        cy={8.667}
        rx={1.333}
        ry={2}
      />
    </g>
  </svg>
);

export default SvgSm;
